export interface AppRequirementsState {
  topoLandInfo: string;
  avoidMinimiseStatement: string;
  propertyVegPlan: boolean | null;
  defendableSpaceStatement: string;
  nativeVegPrecinctPlan: boolean | null;
  nativeVegPrecinctPlanText: string;
  offsetStatement: string;
}

function appRequirementsReducer(state: AppRequirementsState, action: any) {
  switch (action.type) {
    case "change": {
      const prop = action.payload.prop as keyof AppRequirementsState;
      // @ts-ignore
      state[prop] = action.payload.value;
      return state;
    }
    case "clear": {
      return initialState;
    }
    default: {
      throw Error("Unknown action: " + action.type);
    }
  }
}

export const initialState: AppRequirementsState = {
  topoLandInfo: "",
  avoidMinimiseStatement: "",
  propertyVegPlan: null,
  defendableSpaceStatement: "",
  nativeVegPrecinctPlan: null,
  nativeVegPrecinctPlanText: "",
  offsetStatement: "",
};

export default appRequirementsReducer;
